import useUserProfile from './useUserProfile';

const useLanguage = () => {
    const { language } = useUserProfile();

    return language;
};

export default useLanguage;
